import React from 'react';
import { Calendar } from 'lucide-react';
import { generateYears } from '../../utils/dateFilters';

interface TablePeriodSelectorProps {
  selectedMonth: string;
  selectedYear: number;
  onMonthChange: (month: string) => void;
  onYearChange: (year: number) => void;
  months?: string[];
  years?: number[];
  label?: string;
  showYearSelector?: boolean;
}

const defaultMonths = [
  'Todos', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const TablePeriodSelector: React.FC<TablePeriodSelectorProps> = ({
  selectedMonth,
  selectedYear,
  onMonthChange,
  onYearChange,
  months = defaultMonths,
  years = generateYears(),
  label = 'Período de Consulta',
  showYearSelector = true,
}) => (
  <div className="bg-card border border-border rounded-lg mb-6 shadow-none">
    <div className="flex items-center px-6 pt-6 pb-2">
      <Calendar className="h-4 w-4 mr-2 text-muted-foreground" />
      <span className="font-medium text-foreground text-sm tracking-tight">{label}</span>
    </div>

    {/* Selector de Año */}
    {showYearSelector && (
      <div className="px-6 pb-3">
        <div className="flex gap-3 items-center">
          <label htmlFor="year-selector" className="text-xs font-medium text-muted-foreground whitespace-nowrap">
            Año:
          </label>
          <select
            id="year-selector"
            value={selectedYear}
            onChange={(e) => onYearChange(Number(e.target.value))}
            className="bg-secondary text-foreground rounded-[6px] border border-input hover:border-ring focus:border-ring focus:ring-0 focus:outline-none transition shadow-none h-9 pl-4 pr-10 min-w-[120px] font-medium text-sm appearance-none cursor-pointer"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%238A8F98' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 0.75rem center',
              backgroundSize: '12px'
            }}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
    )}

    {/* Selector de Mes */}
    <div className="flex flex-wrap gap-2 px-6 pb-6">
      {months.map((month) => (
        <button
          key={month}
          onClick={() => onMonthChange(month)}
          className={`px-4 py-1.5 text-xs font-medium border transition rounded-[6px] ${selectedMonth === month
            ? 'bg-foreground text-background border-foreground'
            : 'bg-transparent text-muted-foreground border-transparent hover:text-foreground hover:bg-accent'
            }`}
        >
          {month}
        </button>
      ))}
    </div>
  </div>
); 